/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CalendarInventoryCapacityMode = {
    Irrelevant: 'irrelevant',
    Fixed: 'fixed',
    Alterable: 'alterable'
} as const;
export type CalendarInventoryCapacityMode = typeof CalendarInventoryCapacityMode[keyof typeof CalendarInventoryCapacityMode];

